module.exports = __webpack_public_path__ + "img/bg.9708906a.png";